import { Col, Collapse, Row } from "antd";
import { isNull } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setExpandSectionsAction } from "../../../../store/document/documentActions";
import { listVehicleTypesAction } from "../../../../store/vehicle/vehicleActions";
import NoExpiryDocumentSummary from "../NoExpiryDocumentSummary";
import VehicleCustomerPanel from "./VehicleCustomerPanel";
import VehicleDocumentPanel from "./VehicleDocumentPanel";
import VehiclePaymentPanel from "./VehiclePaymentPanel";
import VehicleRegistrationVehiclePanel from "./VehicleRegistrationVehiclePanel";

const VehicleRegistrationView = ({ isNew }) => {
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const [activeKeys, setActiveKeys] = useState(
    isNew ? ["1", "2", "3", "4", "5"] : ["1", "2"]
  );

  const expandSections = useSelector(
    (state) => state.document.selectedUi.expandSections
  );

  useEffect(() => {
    if (!isNull(expandSections)) {
      dispatch(setExpandSectionsAction(null));
      setActiveKeys(expandSections ? ["1", "2", "3", "4", "5"] : []);
    }
  }, [expandSections, dispatch]);

  const onActiveKeyChangeHandler = (keys) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const vehicleTypes = useSelector((state) => state.vehicle.data);

  useEffect(() => {
    if (isNull(vehicleTypes)) {
      dispatch(listVehicleTypesAction());
    }
  }, [vehicleTypes, dispatch]);

  const items = useMemo(
    () => [
      {
        key: "1",
        label: "Summary",
        children: <NoExpiryDocumentSummary isNew={isNew} />,
      },
      {
        key: "2",
        label: "Document",
        children: <VehicleDocumentPanel control={control} isNew={isNew} />,
      },
      {
        key: "3",
        label: "Customer",
        children: <VehicleCustomerPanel control={control} isNew={isNew} />,
      },
      {
        key: "4",
        label: "Vehicle",
        children: <VehicleRegistrationVehiclePanel control={control} />,
      },
      {
        key: "5",
        label: "Payment",
        children: <VehiclePaymentPanel control={control} />,
      },
    ],
    [control, isNew]
  );

  return (
    <>
      <Row>
        <Col span={24}>
          <Collapse
            items={items}
            activeKey={activeKeys}
            onChange={onActiveKeyChangeHandler}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default VehicleRegistrationView;
